import {createNullableContext} from '../context';
import {DashboardScreenProps} from './DashboardScreen';

export const DashboardContext = createNullableContext<DashboardScreenProps>();
